<div class="border-0 px-md-4 py-1 scroll-container" ref="manage_workflow">

    <div v-if="has_parent_context" class="d-flex justify-content-start align-items-center ms-2 mb-2">
      <button
        type="button"
        class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
        @click="go_to_parent_entity"
      >
        <i class="bi bi-arrow-left me-1"></i>
        Back to {{ parent_entity_name }}
      </button>
    </div>

    <div class="card-header glassy-bg shadow border-0 mt-2 rounded-top-lg ms-2 mb-4 p-3">
      <div class="d-flex align-items-center">
        <i class="bx bx-user fs-2 text-primary-blue me-2"></i>
        <div class="d-flex flex-column justify-content-center">

          <p class="fw-bold text-dark mb-0 fs-5 fst-italic d-flex align-items-center pointer"
             @click="open_edit_entity_modal" data-bs-toggle="modal" data-bs-target="#edit_entity_modal">
            {{ entity_name }}
            <i class="bx bx-edit ms-2 text-primary-dark fs-5"></i>
          </p>
          <span class="text-xs mt-1" :style="{ color: get_status_color(application_status) }">
            <span class="text-xs fw-bold text-dark">Application Status :</span> {{ application_status }}
          </span>
        </div>

      </div>
    </div>

    <!-- MASTER TABS -->
    <div class="row mb-4 gx-3 ms-1">
      <div class="col-12 col-md-4 mb-2">
        <div class="card bg-transparent border shadow rounded-lg cursor-pointer p-3 border-2 dashboard-card h-100"
             :class="active_master_tab === 'profile' ? 'active-card btn-primary-dark' : 'bg-white'"
             @click="select_master_tab('profile')">
          <div class="d-flex align-items-center">
            <div class="icon-shape bg-primary text-white rounded-circle me-3 d-flex align-items-center justify-content-center shadow-sm">
              <i class="bx bx-user-pin fs-4"></i>
            </div>
            <div>
              <h6 class="mb-0 text-sm fw-bold">Onboarding Profile</h6>
              <p class="mb-0 text-xxs">Your Application Information</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-4 mb-2">
        <div class="card bg-transparent border shadow rounded-lg cursor-pointer p-3 border-2 dashboard-card h-100"
             :class="active_master_tab === 'documents' ? 'active-card btn-primary-dark' : 'bg-white'"
             @click="select_master_tab('documents')">
          <div class="d-flex align-items-center">
            <div class="icon-shape bg-info text-white rounded-circle me-3 d-flex align-items-center justify-content-center shadow-sm">
              <i class="bx bx-file fs-4"></i>
            </div>
            <div>
              <h6 class="mb-0 text-sm fw-bold">Your Uploaded Documents</h6>
              <p class="mb-0 text-xxs">KYC & Files</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-4 mb-2">
        <div class="card bg-transparent border shadow rounded-lg cursor-pointer p-3 border-2 dashboard-card h-100"
             :class="active_master_tab === 'compliance' ? 'active-card btn-primary-dark' : 'bg-white'"
             @click="select_master_tab('compliance')">
          <div class="d-flex align-items-center">
            <div class="icon-shape bg-warning text-white rounded-circle me-3 d-flex align-items-center justify-content-center shadow-sm">
              <i class="bx bx-check-shield fs-4"></i>

            </div>
            <div>
              <h6 class="mb-0 text-sm fw-bold">Your Compliance Status</h6>
              <p class="mb-0 text-xxs">Risk & Verification</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="overview-application-container">

      <!-- MOBILE: Horizontal scroll pills -->
      <div v-if="active_master_tab === 'profile' && filtered_sub_tabs.length > 0"
           class="d-block d-md-none mb-2 overview-tabs-wrapper">
        <div class="mobile-tabs-scroll d-flex gap-2 overflow-auto px-2 py-2">
          <div v-for="tab in filtered_sub_tabs"
               :key="tab.id"
               class="mobile-tab-pill"
               :class="{ active: active_tab === tab.id }"
               @click="select_tab(tab.id)">
            <i :class="get_tab_icon(tab.id)" class="me-1"></i>
            <span class="text-xxs fw-semibold">{{ tab.label }}</span>
          </div>
        </div>
      </div>

      <!-- DESKTOP: Vertical sidebar tabs -->
      <div v-if="active_master_tab === 'profile' && filtered_sub_tabs.length > 0"
           class="overview-vertical-tabs-container overview-scrollable-container d-none d-md-flex">
        <div v-for="tab in filtered_sub_tabs" :key="tab.id"
             class="overview-floating-tab rounded-lg"
             :class="{ 'active': active_tab === tab.id }"
             @click="select_tab(tab.id)">
          <div class="overview-floating-tab-inner">
            <div class="d-flex align-items-center">
              <!-- Dynamic Icon -->
              <i
                class="me-2 fs-bold fs-6"
                :class="get_tab_icon(tab.id)">
              </i>
              <span class="text-xs fw-semibold">
                {{ tab.label }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="ms-2 overview-dropdown-column rounded-lg w-100 glassy-bg mt-2">
        <div class="overview-accordion-container mb-3 border-0 rounded-lg" id="stages_accordion">

          <div v-if="active_master_tab === 'documents'" class="accordion-item bg-transparent">
            <EntityDocuments
              :application_id="application_id"
              :entity_profile_id="entity_profile_id"
              :key="`entity-documents-${application_id}-${entity_profile_id}`"
            />
          </div>

          <div v-else-if="active_master_tab === 'compliance'" class="accordion-item bg-transparent">
            <OnboardingComplianceComponent :entity_profile_id="entity_profile_id" />
          </div>

          <div v-else-if="active_master_tab === 'profile'">
            <div v-if="content_type === 'dynamic'">
              <div class="p-3">
                <RenderSections
                  :form_main_section_id="dropdown_forms_id(active_tab)"
                  :application_id="application_id"
                  :entity_profile_id="entity_profile_id"
                  :application_form_id="application_form_id"
                />
              </div>
            </div>

            <div v-show="active_tab === 'Overview'" class="accordion-item bg-transparent">
              <ApplicationOverviewDetails
              :application_form_id="application_form_id"  />
            </div>

            <div v-show="active_tab === 'Verification'" class="accordion-item bg-transparent">
              <EntityVerificationResults :entity_profile_id="entity_profile_id" />
            </div>

            <div v-show="active_tab === 'Requests'" class="accordion-item bg-transparent">
              <RequestedInformationUpdate />
            </div>

            <div v-show="active_tab === 'E-Signing'" class="accordion-item bg-transparent p-3">
              <ESigning />
            </div>

            <div v-show="active_tab === 'Invoices'" class="accordion-item bg-transparent">
              <EntityInvoiceOverview />
            </div>

            <div v-if="is_child_entity_type_tab(active_tab)" class="accordion-item bg-transparent p-3">
              <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 mb-3">
                <p class="mb-0 fw-bold text-dark text-x text-uppercase">
                  {{ child_tab_title(active_tab) }}
                </p>

                <div class="d-flex flex-wrap align-items-center gap-2">
                  <button
                    @click="open_share_sub_entity_link_modal(active_tab)"
                    class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow-sm text-dark"
                  >
                    Share {{ child_tab_title(active_tab) }} onboarding link
                  </button>

                  <button
                    @click="open_add_sub_entity_from_child_tab(active_tab)"
                    class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                  >
                    Add {{ child_tab_title(active_tab) }}
                  </button>
                </div>
              </div>

              <FolderList
                v-if="child_tab_items(active_tab).length > 0"
                :items="child_tab_items(active_tab)"
                @view="redirect_to_application_overview"
                @add-sub="handle_folderlist_add"
                @fetch-assigned="fetch_assigned_for_item"
                :moving_to_master_loading="false"
              />

              <div v-else class="text-center py-5 text-muted">
                <i class="fa-solid fa-inbox fa-3x mb-3"></i>
                <p>No {{ child_tab_title(active_tab) }} found</p>
              </div>
            </div>

            <div v-show="active_tab === 'Profile'" class="accordion-item bg-transparent">
              <UserProfileComponent
                :profile_id="viewed_user_id ? null : entity_profile_id"
                :user_identifier="viewed_user_id"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

<!-- Edit Entity Modal -->
 <teleport to="body">
<div class="modal fade" id="edit_entity_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs">Edit Entity Name</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal"
                @click="show_edit_entity_modal = false"></button>
      </div>
        <div class="modal-body">
          <div class="form-group mb-3">
            <label class="form-label text-xxs">Entity Name:</label>
            <input
              type="text"
              v-model.trim="current_edit_entity.name"
              :class="{'is-invalid': entity_name_error}"
              @input="entity_name_error = false"
              class="form-control text-xxs rounded-3 p-2 shadow-sm"
              placeholder="Enter entity name"
              @keyup.enter="save_edited_entity"
            />
            <div v-if="entity_name_error" class="invalid-feedback small">
              Please enter an entity name
            </div>
          </div>
        </div>

        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
            @click="save_edited_entity"
            :disabled="!current_edit_entity.name?.trim()"
            data-bs-dismiss="modal"
          >
            Save
          </button>
        </div>

    </div>
  </div>
</div>
</teleport>

<teleport to="body">
  <div
    class="modal fade"
    id="share_sub_entity_link_modal"
    tabindex="-1"
    aria-labelledby="share_sub_entity_link_modal_label"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header cute-header d-flex align-items-center justify-content-between px-3 py-2">
          <h5 class="modal-title text-white text-xxs m-0" id="share_sub_entity_link_modal_label">
            Share {{ share_child_entity_type_name || 'Sub-Entity' }} onboarding link
          </h5>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body p-3">
          <p class="text-xxs text-muted mb-3">
            This link forces the onboardee to register under the current parent entity as a
            {{ share_child_entity_type_name || 'sub-entity' }}.
          </p>

          <div v-if="is_generating_share_link" class="text-center py-4">
            <div class="spinner-border spinner-border-sm text-primary mb-2" role="status"></div>
            <p class="text-xxs mb-0">Generating secure onboarding link...</p>
          </div>

          <div v-else>
            <div v-if="share_sub_entity_error" class="alert alert-danger text-xxs py-2">
              {{ share_sub_entity_error }}
            </div>

            <div v-else class="form-group">
              <label class="form-label text-xxs">Onboarding Link</label>
              <input
                type="text"
                class="form-control text-xxs rounded-3 p-2 shadow-sm"
                :value="share_sub_entity_link"
                readonly
              />
            </div>
          </div>
        </div>

        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow-sm text-dark"
            @click="generate_share_sub_entity_link"
            :disabled="is_generating_share_link"
          >
            Regenerate
          </button>
          <button
            type="button"
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
            @click="copy_share_sub_entity_link"
            :disabled="!share_sub_entity_link || is_generating_share_link"
          >
            Copy Link
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="assign_sub_entity_modal" tabindex="-1" aria-labelledby="assign_sub_entity_modal_label"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header cute-header d-flex align-items-center justify-content-between px-3 py-2">
          <h5 class="modal-title text-white text-xxs m-0" id="assign_sub_entity_modal_label">Add Sub-Entity</h5>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body p-3">
          <div class="modal-form-group form-group mb-3">
            <label class="modal-form-label form-label text-xxs">Parent Entity Type</label>
            <input type="text" class="modal-form-control form-control text-xxs"
              :value="current_form.parent_name || 'Loading...'" disabled>
          </div>

          <div class="modal-form-group form-group mb-3">
            <label for="assign_sub_entity_type" class="modal-form-label form-label text-xxs">Sub-Entity Type</label>
            <select id="assign_sub_entity_type"
              class="modal-form-select form-select text-xs rounded-small p-2 shadow-sm text-x"
              v-model="assign_sub_entity_type_id" @change="assign_on_sub_entity_change"
              :disabled="assign_sub_entity_options.length === 0 || is_loading_options">
              <option value="" disabled selected>Select sub-entity type</option>
              <option v-for="opt in assign_sub_entity_options" :key="opt.id" :value="opt.id">
                {{ opt.name }}
              </option>
            </select>
            <div v-if="is_loading_options" class="text-info text-xxs mt-1">
              <i class="fas fa-spinner fa-spin me-1"></i>Loading sub-entity types...
            </div>
            <div v-if="assign_sub_entity_options.length === 0 && !is_loading_options" class="text-danger text-xxs mt-1">
              No sub-entity types available for this entity.
            </div>
          </div>

          <div class="modal-form-group form-group mb-3" v-if="assign_form_list.length">
            <label for="assign_form_select" class="modal-form-label form-label text-xxs">Form</label>
            <select id="assign_form_select"
              class="modal-form-select form-select text-xs rounded-small p-2 shadow-sm text-x"
              v-model="assign_selected_form_id" :disabled="assign_form_list.length === 0">
              <option value="" disabled selected>Select form</option>
              <option v-for="form in assign_form_list" :key="form.id" :value="form.id">
                {{ form.form_name }}
              </option>
            </select>
          </div>

          <div class="modal-form-group form-group mb-3" v-else-if="assign_sub_entity_type_id">
            <label class="modal-form-label form-label text-xxs">Form</label>
            <div class="alert alert-info text-xxs p-2">
              Select a sub-entity type to see available forms
            </div>
          </div>

          <div class="modal-form-group form-group mb-3">
            <label for="assign_entity_name" class="modal-form-label form-label text-xxs">Name</label>
            <input id="assign_entity_name" type="text" v-model="assign_entity_name"
              class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
              placeholder="Enter name">
          </div>

          <div class="modal-form-group form-group mb-3">
            <div class="form-check form-switch text-xxs d-flex justify-content-start align-items-center">
              <input type="checkbox" id="email_toggle" v-model="include_email" class="form-check-input" role="switch">
              <label class="form-check-label ms-2" for="email_toggle">
                Allow login and send email invitation
              </label>
            </div>
          </div>

          <div class="modal-form-group form-group mb-3" v-if="include_email">
            <label for="assign_email" class="modal-form-label form-label text-xxs">Email</label>
            <input id="assign_email" type="email" v-model="assign_email"
              class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
              placeholder="Enter email">
          </div>

          <div v-if="validation_error" class="alert alert-danger text-xxs py-2">
            {{ validation_error }}
          </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button type="button" class="btn btn-primary-dark btn-sm px-3 text-xxs shadow-sm"
              @click="save_assign_sub_entity" :disabled="is_saving">
              <span v-if="is_saving">
                <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                Saving...
              </span>
              <span v-else>Save</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>
